import React, { useState, useEffect } from "react";
import axios from "axios";
import { Cookies } from '../../index.js';
import { Helmet } from "react-helmet" ;
import  '../../app_structure/truyen.css';
import { Link } from 'react-router-dom';
import AdSense from 'react-adsense';
import  '../../app_structure/truyen.scss';
import { useLocation , useNavigate } from 'react-router-dom';
import Parser from 'html-react-parser';
const Theloaitruyenchu = () => {
  const [random, setRandom] = useState(0);
  const [tatquangcao, settatquangcao] = useState(Cookies.get('tatquangcao'));

    const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState(null);
  const [userss, setUserss] = useState(null);
  const [size, setSize] = useState(null);
  const [hientruyen, setHientruyen] = useState(null);
  const [error, setError] = useState(null);
  const [listpage, setListpage] = useState(null);
  const [infoBox, setInfoBox] = useState(null);
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);
  const [tentheloai, settentheloai] = useState(0);
  const [page , setpage ] = useState(0);
  const location = useLocation();
  const Sfsdfsdfsdf = () => {
    const params = new URLSearchParams(window.location.search);

    setpage( params.get("page")); // lấy giá trị "11"
    const url = window.location.href;
    var splitter = "/the-loai/";

    var urlsplit = url.split(splitter)[1];
    urlsplit = urlsplit.split('?');
    urlsplit = urlsplit[0];
    settentheloai(urlsplit); // lấy giá trị "adventure"
};
  useEffect(() => {
    hienads2() ;
    Sfsdfsdfsdf() ;
    fetchData();
    const randomNumber = Math.floor(Math.random() * 2);
    setRandom(randomNumber);
  }, []);

  const fetchData = () => {
    const url = window.location.href;
    var splitter = "/the-loai/";

    var urlsplit = url.split(splitter)[1];
    var dbshcfhsajkhcjas = "https://hust.media/truyenchuapi/the-loai.php/?linktruyen=" + urlsplit;

    setError(null);
    setUsers(null);
    setLoading(true);
    const apikey = Cookies.get('apikey');
    console.log(apikey);
    axios.get(dbshcfhsajkhcjas).then((response) => {
      setLoading(false);
      setUsers(JSON.stringify(response.data));
      setUserss(response.data.listtruyen);
      setListpage(response.data.listpage);
      console.log(userss);
    });
  };
  function hienads2() {
    const script2 = document.createElement("script");
    script2.setAttribute("data-cfasync", "false");
    script2.setAttribute("type", "text/javascript");
    script2.setAttribute("src", "//hhbypdoecp.com/lv/esnk/1978453/code.js");
    script2.async = true;
    script2.id = "__clb-1978453";
  
    document.getElementById("clickadu2-container").appendChild(script2);
  
    if (window.clickadu_creativ) {
      window.clickadu_creativ({
        slot: '1978453',
        container: 'clickadu2-container',
        width: 300,
        height: 250,
      });
    }
  } ;
  const tattruyen = (link) => {
   
    setUserss("");
    setHientruyen("ok");
    setLoading(true);
    navigate(link);
  };

  useEffect(() => {
    if (infoBox) {
      var size = infoBox.clientHeight / 20;
      setSize(size);
      setHeight(size + "px");
      console.log(height);
    }
  }, [infoBox]);

  return (
    <>
    {random == 1 && tatquangcao != 'ok'  ? (
  <Helmet>
    {/* <script async="async" data-cfasync="false" src="//ophoacit.com/1?z=5904788"></script> */}
  </Helmet>
)  : (
<></>
)

}
        <div className=" users">
      <div className=" mt-0" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
       
          Page: {page} {tentheloai}
     
      </div>
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
      {listpage &&
            <div>{Parser(listpage)}</div>
        }
      </div>
      { !userss && (
        <>
           <div className="loading" style={{ display: loading ? "block" : "none" }}>
        <div className="l-container ádasdasdasdasd">
          <div ref={setInfoBox}>
            <div className="b-game-card">
              <div className="b-game-card__cover">
                <div className="b-game-card__cover" style={{ backgroundImage: "url(https://img.pikbest.com/png-images/20190918/cartoon-snail-loading-loading-gif-animation_2734139.png!bw340)" }}></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    
        </>
   
  )}
      <div className="error" style={{ display: error ? "block" : "none" }}>
        {error}
      </div>

      <div style={{ display: hientruyen ? "block" : "none" }}></div>
      <ul  style={{ display: userss ? "block" : "none" }}>
        <div className="bodyokok  l-container ádasdasdasdasd">
          {userss &&
            userss.map(({ tentruyen, sochap, linktruyen, linkanh }) => (
              <li key={linktruyen}>
                <div onClick={() => tattruyen(linktruyen)} >
                  <div className="b-game-card" ref={setInfoBox}>
                    <div className="b-game-card__cover">
                      <span className="test" style={{ fontSize: height }}>
                        {tentruyen}
                      </span>

                      <span className="test" style={{ fontSize: height }}>
                        số chap {sochap}
                      </span>
                      <img src={linkanh} alt="Girl in a jacket" width="500" height="600" />
                    </div>
                  </div>
                </div>
              </li>
            ))}
        </div>
        <div className="mt-0 max-h-16 mx-4">
                <div className="cards">
    <AdSense.Google
          client="ca-pub-4574266110812955"
          slot="1627514116"
          style={{ display: 'block', height: 50 }}
          format=""
        /> </div>
        </div>
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
        {listpage &&
            <div>{Parser(listpage)}</div>
        }
        </div>
 
     
      </ul>
      <div className="flex items-center justify-center">
  <div className="cards">

      <div id="clickadu2-container"></div>
    </div>
    </div><br />  <br />
    </div>
    </>

  );
};

export default Theloaitruyenchu;